import { theme, rem } from '@nobia/zeus-components/lib/styled'

export default {
  typography: {
    pageTitle: {
      fontSize: rem(36),
      fontSizeDesktop: rem(44),
    },
    collectionLabel: {
      fontSize: '18px',
      letterSpacing: '0.6px',
    },
    modalHeadline: {
      fontSizeDesktop: '18px',
      fontSize: '18px',
    },
    numberOfImages: {
      fontSize: rem(12),
      lineHeight: '34px',
    },
  },
  backgroundElement: {
    display: 'fixed',
  },
  collectionWrapper: {
    top: `calc(100vh - 79px) !important`,
    height: `79px`,
    backgroundColor: '#f5f5f5',
    width: `100%`,
    flexDirection: 'row',
    alignItems: 'center',
    labelAnimationFrom: {
      marginLeft: '35px',
      opacity: 0,
    },
    labelAnimationTo: {
      marginLeft: '35px',
      opacity: 1,
    },
  },
  numberOfImages: {
    top: `calc(100vh - 48px) !important`,
    position: 'relative',
    margin: '0 0 0 7px',
    marginDesktop: '0 0 0 102px',
    height: '22px',
  },
  styledLink: {
    color: theme('colors.black'),
    border: 'solid #333333',
    borderWidth: '1px',
    marginRight: '76px',
    marginRightDesktop: '172px',
    textAlign: 'center',
    padding: '5px 10px',
  },
  collectionLabel: {
    margin: '0 0 0 7px',
    marginDesktop: '0 0 0 102px',
    lineHeight: '34px',
  },
}
